/* eslint-disable @typescript-eslint/ban-ts-comment */
import {
    Box,
    Collapse,
    FormControl,
    FormErrorMessage,
    FormLabel,
    Select,
    Skeleton
} from '@chakra-ui/react'
import { Icon } from 'components/atoms/Icon'
import React, { FormEventHandler, forwardRef, useEffect, useState } from 'react'
import { FieldError } from 'react-hook-form'
import { validatorsForm } from '../../utils/validatorsForm'
import { optionsDefault } from './constants'
import { SelectBuildProps } from './interfaces'

const SelectBuildFC: React.ForwardRefRenderFunction<
    HTMLSelectElement,
    SelectBuildProps
> = (
    {
        id,
        label,
        options,
        optionsType,
        placeholder,
        err,
        isLoading,
        isSearching,
        iconName,
        isDisable,
        ...props
    },

    ref
) => {
    const named = id.split('.').slice(-1)[0] || ''

    const [optionsCurrent, setOptionsCurrent] = useState(
        (optionsType && optionsDefault[optionsType]) || options
    )

    const handleErrorMessage = (err: FieldError): string => {
        const erro = validatorsForm[named]
            ? validatorsForm[named][err.type]
            : (err.message as string)
        return erro
    }

    const handleChange = (
        e: unknown
    ): FormEventHandler<HTMLInputElement> | undefined => {
        return e as FormEventHandler<HTMLInputElement>
    }

    useEffect(() => {
        setOptionsCurrent(
            (optionsType && optionsDefault[optionsType]) || options
        )
    }, [optionsType, options])

    return (
        <>
            {isLoading ? (
                <>
                    <Skeleton
                        height="24px"
                        width="100%"
                        borderRadius="md"
                        marginBottom={2}
                    />
                    <Skeleton height="40px" width="full" borderRadius="md">
                        <select ref={ref} hidden />
                    </Skeleton>
                </>
            ) : (
                <FormControl isInvalid={!!err} isRequired={props?.required}>
                    <FormLabel htmlFor={id}>{label}</FormLabel>

                    {isSearching ? (
                        <Skeleton height="40px" width="full" borderRadius="md">
                            <select data-testid={id} ref={ref} hidden />
                        </Skeleton>
                    ) : (
                        <Select
                            data-testid={id}
                            placeholder={
                                placeholder || 'Clique para selecionar'
                            }
                            {...props}
                            onChangeCapture={handleChange}
                            ref={ref}
                            required={false}
                            icon={iconName && <Icon name={iconName} />}
                            disabled={isDisable}
                        >
                            {optionsCurrent &&
                                optionsCurrent.map(
                                    ({ value, text, ...option }) => (
                                        <option
                                            data-testid={`option-${id}-${value}`}
                                            key={`option-${id}-${value}`}
                                            {...option}
                                            value={value}
                                        >
                                            {text}
                                        </option>
                                    )
                                )}
                        </Select>
                    )}
                    <Collapse in={!!err} animateOpacity>
                        <Box minH="15px">
                            <FormErrorMessage
                                position="relative"
                                mt={1}
                                fontSize="xs"
                            >
                                {err && handleErrorMessage(err)}
                            </FormErrorMessage>
                        </Box>
                    </Collapse>
                </FormControl>
            )}
        </>
    )
}

export const SelectBuild = forwardRef(SelectBuildFC)
